( function( $ ){

    /**
     * Vaildator
     */
    const validator = (function(){

        let password_set = false;

        function validate(){
            
            let errors = [];
            $( '.woocommerce-form-row' ).each( function(){

                const $field = $( this ).find( 'input, select' ).first();
                if( $field.hasClass( 'not-required' ) || $field.hasClass( 'definitely-required' ) ){
                    return;
                }

                if( ! $field.is( ':visible' ) && $field.is( 'input' ) ){
                    return;
                }

                const value = $field.val();
                if( '' == value ){
                    errors.push({
                        'field': $field.attr( 'id' ),
                        'message': 'This field is required'
                    });
                    return;
                }

                const validation_string = $field.attr( 'data-validate' );
                if( !validation_string ){
                    return;
                }

                const validation_to_run = validation_string.split( '|' );

                for( let i = 0; i < validation_to_run.length; i++ ){
                    let val_function = validation_to_run[i];
                    if( validators.hasOwnProperty( val_function ) ){
                        let error_message = validators[ val_function ]( value );
                        if( error_message !== true ){
                            errors.push( {
                                'field': $field.attr( 'id' ),
                                'message': error_message
                            } );
                        }
                    }
                }

            } );

            return ( errors.length == 0) ? true : errors;

        }

        const validators = {

            email: function( value ){
                const email_regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                if( !email_regex.test( value ) ){
                    return 'Please enter a valid email';
                }
                return true;
            },

            password: function( value ){
                if( value.length < 8 ){
                    return 'Your password must be a minimum of 8 characters';
                }
                password_set = value;
                return true;
            },

            passwords_match: function( value ){
                if( value !== password_set ){
                    return 'Passwords do not match';
                }
                return true;
            }

        };

        return {
            validate: validate
        };

    })();

    /**
     * Clear Errors
     */
    function clearErrors(){
        $( '.error' ).removeClass( 'error' );
        $( '.error-msg' ).remove();
    }

    /**
     * Clear a single error
     */
    function clearError(){
        $( this ).removeClass( 'error' );
        $( this ).closest( '.woocommerce-form-row').find( '.error-msg' ).remove();
    }

    /**
     * Show Form Errors
     */
    function showErrors( errors ){
        for( let i = 0; i < errors.length; i++ ){
            const error = errors[i];
            $( '#' + error.field ).addClass( 'error' );
            $( '#' + error.field ).closest('.woocommerce-form-row').append( '<span class="error-msg">' + error.message + '</span>' );
        }
        $( '.error' ).eq(0).focus();
    }

    $( document ).on( 'change', 'input, select', clearError );

    // Form Submission
    $( document ).on( 'submit', '.woocommerce-form-register', function( e ){
        
        clearErrors();

        const valid_or_errors = validator.validate();
        if( true !== valid_or_errors ){
            showErrors( valid_or_errors );
            e.preventDefault();
        }

    });

})( jQuery );